module.exports = __webpack_public_path__ + "static/media/guilt-large@2x.8fdd632b.png";